import { render, staticRenderFns } from "./DeleteReturnOrderItem.vue?vue&type=template&id=70a8be00&scoped=true&"
import script from "./DeleteReturnOrderItem.vue?vue&type=script&lang=js&"
export * from "./DeleteReturnOrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a8be00",
  null
  
)

export default component.exports